module.exports = __webpack_public_path__ + "static/media/holiday_Hero20221216.1c4ed2ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/holiday_Hero20221216.jpg
// module id = 352
// module chunks = 0